<template>
  <svg
    :class="className"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 17L17 7M17 7H7M17 7V17"
      :stroke="stroke"
      :stroke-width="strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7 7L17 17M7 17H17M7 17V7"
      :stroke="stroke"
      :stroke-width="strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'DoubleArrowIcon',
  props: {
    className: {
      type: String,
      default: '',
    },
    stroke: {
      type: String,
      default: '#2C3E50',
    },
    strokeWidth: {
      type: Number,
      default: 2,
    },
  },
};
</script>
